import {
  Card,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { Button } from '@superdispatch/ui-lab';
import { trackLoadboardEvent } from '../../core/LoadboardAnalytics';
import { useOpenAddSavedSearchPage } from '../../core/saved-searches/SavedSearchState';
import { PostingSavedSearchDTO } from '../../data/dto/PostingSavedSearchDTO';
import { useLoadboardContext } from '../../data/LoadboardContext';
import { useSavedSearches } from '../../data/LoadboardSavedSearchesAPI';
import { SavedSearchEmptyCard } from '../SavedSearchEmptyCard';
import { HomeScreenSavedSearchListItem } from './HomeScreenSavedSearchListItem';

export function HomeScreenSavedSearchList() {
  const {
    data: savedSearches,
    error: savedSearchesError,
    isInitialLoading: isSavedSearchesLoading,
  } = useSavedSearches();

  const openAddSavedSearchPage = useOpenAddSavedSearchPage({ savedSearches });
  const {
    router: { openPostingsScreen },
  } = useLoadboardContext();

  if (savedSearchesError) {
    // TODO Handle error state
    return null;
  }

  if (isSavedSearchesLoading) {
    return (
      <Card>
        <List>
          <ListItem>
            <Skeleton width="100%" height="1.5em" />
          </ListItem>

          <ListItem>
            <Skeleton width="80%" height="1em" />
          </ListItem>

          <ListItem button={true}>
            <Skeleton width="100%" height="1em" />
          </ListItem>
        </List>
      </Card>
    );
  }

  if (savedSearches && savedSearches.length === 0) {
    return (
      <SavedSearchEmptyCard
        onAddClick={() => {
          openAddSavedSearchPage('Load Alert Card');
        }}
      />
    );
  }

  return (
    <Card>
      <List disablePadding={true}>
        <ListItem>
          <ListItemText>
            <Typography variant="h3">Load Alerts</Typography>
          </ListItemText>

          <ListItemIcon>
            <Button
              variant="text"
              onClick={() => {
                openAddSavedSearchPage('Load Alert Card');
              }}
            >
              Create New
            </Button>
          </ListItemIcon>
        </ListItem>

        {savedSearches?.slice(0, 3).map((item: PostingSavedSearchDTO) => (
          <HomeScreenSavedSearchListItem key={item.guid} savedSearch={item} />
        ))}

        <ListItem
          button={true}
          onClick={() => {
            trackLoadboardEvent({
              name: 'SLB: Clicked Tab',
              tabName: 'saved-search',
            });
            openPostingsScreen('saved-search');
          }}
        >
          <ListItemText>
            <Typography color="primary" align="center">
              View All
            </Typography>
          </ListItemText>
        </ListItem>
      </List>
    </Card>
  );
}
